import { render, staticRenderFns } from "./VectorCanvas.vue?vue&type=template&id=14ab62ed&"
import script from "./VectorCanvas.vue?vue&type=script&lang=js&"
export * from "./VectorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./VectorCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VectorCanvas.vue"
export default component.exports